import { render, staticRenderFns } from "./TabsDigitalDisplays.vue?vue&type=template&id=1f4d616b&scoped=true"
import script from "./TabsDigitalDisplays.vue?vue&type=script&lang=js"
export * from "./TabsDigitalDisplays.vue?vue&type=script&lang=js"
import style0 from "./TabsDigitalDisplays.vue?vue&type=style&index=0&id=1f4d616b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d616b",
  null
  
)

export default component.exports